import * as React from 'react';
import { SurveyEditSteps } from '../../common/constants';

interface iProps {
    step: number,
    moveNextStep: any,
}

class TopNav extends React.PureComponent<iProps> {

    public render() {
        return (
            <React.Fragment>
                { this.renderHeaderLine() }
            </React.Fragment>
        );
    }

    private renderHeaderLine() {
        
        return (
            <>
            <div className="row d-block d-sm-none">
                <div className="col">
                    <div className="progress">
                        <div className="progress-bar" role="progressbar"></div>
                        <div className="progress-bar bg-success" role="progressbar" style={{ width: ((this.props.step - 1) / 3 * 100) + '%' }}></div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col d-none d-sm-block">
                    <ul className="list-group list-group-horizontal" id="progress-menu">
                        
                        {this.getLiItem('Start', SurveyEditSteps.Start, SurveyEditSteps.Start)}
                        {this.getLiItem('Group', SurveyEditSteps.Group, SurveyEditSteps.Group)}
                        {this.getLiItem('Question', SurveyEditSteps.Question, SurveyEditSteps.Question)}

                        {this.getLiItem('Summary', SurveyEditSteps.Summary, SurveyEditSteps.Question)}
                        {this.getLiItem('Endnote', SurveyEditSteps.Endnote, SurveyEditSteps.Summary)}
                        {this.getLiItem('Preview', SurveyEditSteps.Preview, SurveyEditSteps.Endnote)}
                        {this.getLiItem('Save', SurveyEditSteps.Publish, SurveyEditSteps.Preview)}
 
                    </ul>
                </div>
            </div>
            </>);
    }

    getLiItem(stepName: string, stepNum: number, completedNum: number ) {

        return (
            <li className={`opo-list-group-item ${this.props.step > completedNum ? 'visited completed' : ''} ${this.props.step === stepNum ? 'active' : ''}`}>
                <p>
                    <span onClick={() => this.props.moveNextStep(stepNum)}>{stepName}</span>
                </p>
            </li>
        );
    }
};

export default TopNav;
